import React, { useState } from "react";

export default function TemplateFilter({
  category,
  setCategory,
  search,
  setSearch,
  searchType,
  setSearchType,
  handleSearch,
}) {
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [searchTypeDropdownOpen, setSearchTypeDropdownOpen] = useState(false);

  const categories = [
    { value: "ALL", label: "전체" },
    { value: "BUDGET", label: "회계" },
    { value: "EVENT", label: "행사/사업" },
    { value: "ADMINISTRATION", label: "행정/운영" },
    { value: "ETC", label: "기타" },
  ];

  const searchTypes = [
    { value: "TITLE", label: "제목" },
    { value: "CONTENT", label: "내용" },
  ];

  const selectedCategory =
    categories.find((item) => item.value === category)?.label || "전체";

  const selectedSearchType =
    searchTypes.find((item) => item.value === searchType)?.label || "제목";

  return (
    <div className="cc-unit-template-filter">
      <div className="cc-unit-template-filter-left">
        <div className="cc-unit-template-dropdown">
          <button
            className="cc-unit-template-dropdown-btn"
            onClick={() => setCategoryDropdownOpen((v) => !v)}
            type="button"
          >
            {selectedCategory}
            <svg
              width="14"
              height="8"
              viewBox="0 0 24 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                transform: categoryDropdownOpen
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            >
              <polyline points="2 2 12 10 22 2" />
            </svg>
          </button>

          {categoryDropdownOpen && (
            <ul className="cc-unit-template-dropdown-list">
              {categories.map((item) => (
                <li
                  key={item.value}
                  className={`cc-unit-template-dropdown-item ${
                    category === item.value ? "active" : ""
                  }`}
                  onClick={() => {
                    setCategory(item.value);
                    setCategoryDropdownOpen(false);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="cc-unit-template-filter-right">
        <div className="cc-unit-template-dropdown">
          <button
            className="cc-unit-template-dropdown-btn"
            onClick={() => setSearchTypeDropdownOpen((v) => !v)}
            type="button"
          >
            {selectedSearchType}
            <svg
              width="14"
              height="8"
              viewBox="0 0 24 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                transform: searchTypeDropdownOpen
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            >
              <polyline points="2 2 12 10 22 2" />
            </svg>
          </button>

          {searchTypeDropdownOpen && (
            <ul className="cc-unit-template-dropdown-list">
              {searchTypes.map((item) => (
                <li
                  key={item.value}
                  className={`cc-unit-template-dropdown-item ${
                    searchType === item.value ? "active" : ""
                  }`}
                  onClick={() => {
                    setSearchType(item.value);
                    setSearchTypeDropdownOpen(false);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="cc-unit-template-search-wrap">
          <input
            className="cc-unit-template-search-input"
            type="text"
            placeholder="검색어를 입력하세요."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />

          <button
            className="cc-unit-template-search-btn"
            onClick={handleSearch}
            type="button"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}